// Meter class that generates a number correlated to audio volume.
// The meter class itself displays nothing, but it makes the
// instantaneous and time-decaying volumes available for inspection.
// It also reports on the fraction of samples that were at or near
// the top of the measurement range.
export class SoundMeter {
	context: AudioContext;
	instant = 0.0;
	slow = 0.0;
	clip = 0.0;
	mic: MediaStreamAudioSourceNode;
	script: ScriptProcessorNode;
	clientid: string;
	onLevel?: (level: number) => void;

	constructor(clientid: string, stream: MediaStream, onLevel?: (level: number) => void) {
		if (window.AudioContext) this.context = new AudioContext();
		//@ts-ignore
		else if (window.webkitAudioContext) this.context = new webkitAudioContext();
		else return;

		this.clientid = clientid;
		this.onLevel = onLevel;
		this.script = this.context.createScriptProcessor(2048, 1, 1);
		this.script.onaudioprocess = event => {
			const input = event.inputBuffer.getChannelData(0);
			let i;
			let sum = 0.0;
			let clipcount = 0;
			for (i = 0; i < input.length; ++i) {
				sum += input[i] * input[i];
				if (Math.abs(input[i]) > 0.99) {
					clipcount += 1;
				}
			}
			this.instant = Math.sqrt(sum / input.length);
			this.slow = 0.95 * this.slow + 0.05 * this.instant;
			this.clip = clipcount / input.length;
		};

		this.connectToSource(stream);
		setInterval(this._emit.bind(this), 1000);
	}

	_emit() {
		const level = this.instant;

		const el = document.querySelector('#circle-' + this.clientid);
		if (el) {
			if (level >= 0.001) {
				el.classList.add('pulse');
				setTimeout(() => el.classList.remove('pulse'), 2000);
			}
		}

		if (this.onLevel) this.onLevel(level);
	}

	connectToSource(stream: MediaStream) {
		if (!this.context) return;
		try {
			this.mic = this.context.createMediaStreamSource(stream);
			this.mic.connect(this.script);
			// necessary to make sample run, but should not be.
			this.script.connect(this.context.destination);
			this._emit();
		} catch (e) {
			console.error(e);
		}
	}
}
